// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CircleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CircleIcon" ref={forwardedRef} {...props}>
      <path d="M10 16.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13m0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CircleIcon = /* @__PURE__ */ Object.assign(CircleIconComponent, {
  displayName: 'CircleIcon',
});
